import { useEffect, useState } from "react";
import { trackEvent } from "../utils/segment";
import { toast } from "react-toastify";

export function Footer({ collectionFooter = false }) {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (email) {
      const timeout = setTimeout(() => {
        trackEvent("Email Address Provided", { email });
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [email]);

  const handleSubscribe = () => {
    if (!email) return toast.error("Please enter an email");
    trackEvent("Email Subscribed", { email });
    toast.success("You have been subscribed to our newsletter");
  };

  return false ? (
    <div className="_footer">
      <div className="join-the-party-section">
        <h4>Join the Party</h4>
        <p>Get early access to new flavors, exclusive events & surprises</p>
        <div className="input-group-flex">
          <input
            type="text"
            placeholder="Your email"
            onChange={({ target: { value } }) => setEmail(value)}
          />
          <button onClick={handleSubscribe}>Subscribe</button>
        </div>
      </div>
      <div className="follow-us-section">
        <h4>Follow us</h4>
        <ul>
          <li
            onClick={() => {
              window.open(
                "https://www.instagram.com/amabile_di_rosa/",
                "_blank"
              );
              trackEvent("Instagram Clicked");
            }}
          >
            <i className="bi bi-instagram"></i>
          </li>
          <li
            onClick={() => {
              window.open("https://www.facebook.com/amabiledirosa/", "_blank");
              trackEvent("Facebook Clicked");
            }}
          >
            <i className="bi bi-facebook"></i>
          </li>
          <li
            onClick={() => {
              window.open("https://www.twitter.com/amabiledirosa/", "_blank");
              trackEvent("Twitter Clicked");
            }}
          >
            <i className="bi bi-twitter-x"></i>
          </li>
        </ul>
      </div>
      <div className="contact-us-section">
        <h4>Contact</h4>
        <a
          href="mailto:hello@amabile.com"
          onClick={() => trackEvent("Contact Email Clicked")}
        >
          hello@amabile.com
        </a>
        <a
          href="tel:+1 (555) 123-4567"
          onClick={() => trackEvent("Contact Phone Clicked")}
        >
          +1 (555) 123-4567
        </a>
      </div>
    </div>
  ) : (
    <div className="_footer collection-footer">
      <div className="collection-footer-flex">
        <div className="first-section">
          <h4>Amabile di Rosa</h4>
          <p>Juicy Italian wines, best served with your favorite people</p>
        </div>
        <div className="collection-section">
          <h4>Collection</h4>
          <ul>
            <li
              onClick={() =>
                trackEvent("Collection Clicked", { collection: "sweet" })
              }
            >
              <a href="/our-wines#sweet">Sweet</a>
            </li>
            <li
              onClick={() =>
                trackEvent("Collection Clicked", { collection: "sparkling" })
              }
            >
              <a href="/our-wines#sparkling">Sparkling</a>
            </li>
            <li
              onClick={() =>
                trackEvent("Collection Clicked", {
                  collection: "non-alcoholic",
                })
              }
            >
              <a href="/our-wines#non-alcoholic">Non-Alcholic</a>
            </li>
            <li
              onClick={() =>
                trackEvent("Collection Clicked", {
                  collection: "wines-in-cans",
                })
              }
            >
              <a href="/our-wines#wines-in-cans">Wines in Cans</a>
            </li>
          </ul>
        </div>
        <div className="follow-us-section">
          <h4>Connect</h4>
          <ul>
            <li onClick={() => trackEvent("Instagram Clicked")}>
              <a
                href="http://instagram.com/amabiledirosa"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-instagram"></i>
              </a>
            </li>
            <li onClick={() => trackEvent("Facebook Clicked")}>
              <a
                href="https://tiktok.com/@amabiledirosa"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-tiktok"></i>
              </a>
            </li>
            <li onClick={() => trackEvent("Twitter Clicked")}>
              <a
                href="https://open.spotify.com/user/31lfejx4ccbvlj3my2bqfqccgwmu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-spotify"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="newsletter-section">
          <h4>Newsletter</h4>
          <input className="newsletter-input" placeholder="Enter your email" />
          <button>Subscribe</button>
        </div>
      </div>
      <div className="base-footer">
        <p>
          &copy; {new Date().getFullYear()} Amabile di Rosa. All rights reserved
        </p>
        <i className="bi bi-dot"></i>
        <a
          onClick={() => window.open("/privacy-terms#privacy")}
          href="/privacy-terms#privacy"
        >
          Privacy Policy
        </a>
        <i className="bi bi-dot"></i>
        <a
          onClick={() => window.open("/privacy-terms#terms")}
          href="/privacy-terms#terms"
        >
          Terms of Use
        </a>
      </div>
    </div>
  );
}
